import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import {unregister} from './registerServiceWorker';
import { getEnvironmentVariables } from './services/appServices/appService';


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const baseUrl = window.location.origin;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
export const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const url = './releasevariables.json';
fetch(url)
.then(res => res.json())
.then(() => {
   getEnvironmentVariables().then(envResponse => {
    root.render(
      <Provider store={store}>
          <App history={store.reduxHistory} env={envResponse.data}/>
      </Provider>
    );
   })
   .catch(() => {
      alert("Failed to pull environment data")
   })
})
.catch(() => {
  alert("Failed to pull release variables");
})

unregister();
